// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__mID-U","Logo":"Auth_Logo__GD4nH","Title":"Auth_Title__+8rvP","Error":"Auth_Error__YFggd"};